import React from 'react';
import { Grid } from '@mui/material';
import CancelShipment from './CancelOrder';
import RepeatOrder from './RepeatOrder';
import { userLogin } from '@Services/hasAdminAccess';

interface PropsType {
  shipmentStatus: string;
  accountId?: string;
  isInTransit?: boolean;
  showAlert?: boolean;
  isVoidAllowed?: boolean;
  isCancelAllowed?: boolean;
}

function CancelAndTrackShipment({
  shipmentStatus,
  accountId,
  isInTransit,
  showAlert = false,
  isVoidAllowed = false,
  isCancelAllowed = false,
}: PropsType) {
  const isUserLogin = userLogin();

  return (
    <Grid item display={'flex'}>
      {isUserLogin ? (
        <div>{shipmentStatus === 'placed' && !isInTransit && <CancelShipment disabled={showAlert} />}</div>
      ) : (
        <>
          {isInTransit ? (
            <div>
              {shipmentStatus !== 'delivered' && isVoidAllowed && (
                <CancelShipment disabled={showAlert} isVoidMode={!!isInTransit} />
              )}
            </div>
          ) : (
            <div>
              {(shipmentStatus === 'placed' ||
                shipmentStatus === 'forwarded' ||
                shipmentStatus === 'at_warehouse' ||
                shipmentStatus === 'pickup_failed') &&
                isCancelAllowed && <CancelShipment disabled={showAlert} isVoidMode={!!isInTransit} />}
            </div>
          )}
        </>
      )}
      <div>{<RepeatOrder accountId={accountId} />}</div>
    </Grid>
  );
}

export default CancelAndTrackShipment;
